import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    // Redirect to landing or dashboard
    window.REACT_APP_NAVIGATE('/');
  }, []);

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center">
      <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}